import { useState, useEffect, useMemo } from 'react';

export function useThreadSummary(events, threadURN) {
  const [remote, setRemote] = useState(null);

  useEffect(() => {
    if (!threadURN) return;
    let cancelled = false;
    fetch(`/api/threads/${encodeURIComponent(threadURN)}/summary`)
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (!cancelled && data) setRemote(data); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [threadURN]);

  const local = useMemo(() => deriveLocalSummary(events, threadURN), [events, threadURN]);
  return remote ?? local;
}

function deriveLocalSummary(events, threadURN) {
  let lastUser = null;
  let lastAssistant = null;
  let lastAssistantSeq = null;
  for (const ev of events) {
    const evType = ev?.event_type || ev?.type || '';
    if (evType !== 'message.created' && evType !== 'message') continue;
    const body = ev?.body || {};
    const role = body.role || body.author || body.from || ev?.actor_id || '';
    const text = (typeof body.content === 'string' && body.content)
      || (typeof body.text === 'string' && body.text) || '';
    if (!text) continue;
    if (role === 'user' || role === 'human') {
      lastUser = text;
    } else {
      lastAssistant = text;
      lastAssistantSeq = ev?.seq ?? ev?.stream_seq ?? null;
    }
  }
  if (!lastUser && !lastAssistant) return null;
  const question = lastUser || '';
  const title = question.slice(0, 80) || (threadURN ? threadURN.split(':').pop() : 'Conversation');
  const rawBody = lastAssistant || '';
  const body = rawBody.length > 200 ? rawBody.slice(0, 200) + '…' : rawBody;
  return { title, body, asOfSeq: lastAssistantSeq, source: 'client-template' };
}
